import { useMemo, useState } from "react";

export function sortRows(rows, key, dir = "desc") {
  const list = [...(rows || [])];
  const mul = dir === "asc" ? 1 : -1;
  list.sort((a, b) => {
    const va = a?.[key];
    const vb = b?.[key];
    if (va == null && vb == null) return 0;
    if (va == null) return 1;
    if (vb == null) return -1;
    if (typeof va === "number" && typeof vb === "number") return (va - vb) * mul;
    return String(va).localeCompare(String(vb), undefined, { numeric: true, sensitivity: "base" }) * mul;
  });
  return list;
}

export function useSortedPage(rows, { defaultKey = "created_at", defaultDir = "desc", pageSize = 20 } = {}) {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDir, setSortDir] = useState(defaultDir);
  const [page, setPage] = useState(1);

  const sorted = useMemo(() => sortRows(rows, sortKey, sortDir), [rows, sortKey, sortDir]);
  const total = sorted.length;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, pages);
  const slice = sorted.slice((safePage - 1) * pageSize, safePage * pageSize);

  const toggleSort = (key) => {
    if (sortKey === key) setSortDir((d) => (d === "desc" ? "asc" : "desc"));
    else {
      setSortKey(key);
      setSortDir("desc");
    }
    setPage(1);
  };

  return { slice, total, page: safePage, pages, setPage, sortKey, sortDir, toggleSort, pageSize };
}

export function SortTh({ label, k, sortKey, sortDir, onSort }) {
  const active = sortKey === k;
  return (
    <th
      onClick={() => onSort(k)}
      className="text-left py-3 px-4 text-xs font-semibold text-[#673c96] select-none cursor-pointer hover:bg-[#673c96]/5"
    >
      <span className="inline-flex items-center gap-1">
        {label}
        <span className="text-[10px]">{active ? (sortDir === "asc" ? "↑" : "↓") : ""}</span>
      </span>
    </th>
  );
}

export function PageBar({ page, pages, total, setPage, noun = "rows" }) {
  if (total <= 0) return null;
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-3 text-xs text-[#673c96] border-t border-[#673c96]/10">
      <span>{total} {noun}</span>
      <div className="flex items-center gap-2">
        <button type="button" disabled={page <= 1} onClick={() => setPage(page - 1)}
          className="px-2 py-1 rounded border disabled:opacity-40">Prev</button>
        <span>Page {page} / {pages}</span>
        <button type="button" disabled={page >= pages} onClick={() => setPage(page + 1)}
          className="px-2 py-1 rounded border disabled:opacity-40">Next</button>
      </div>
    </div>
  );
}
